export const dataHolder = {
  db: null,
};
